import React from 'react'

const DocRowImage =(props)=>{
    const {formObject, viewData, imgHeight} = props;

    const src = formObject.getValueFromKey(viewData, "dataList.src", "");

    if (src) {
        const lsrc = formObject.getValueFromKey(viewData, "dataList.lsrc", "");

        return (
            <div className="uiImage">
                <a href={lsrc} target="_LargeImage">
                    <img alt="" height={imgHeight} src={src} 
                      onError={e => { e.target.style.display = 'none'; }}
                    />
                </a>
            </div>
        )
    }

    return (
        null
    )
}

export default DocRowImage